module.exports = __webpack_public_path__ + "img/biking.5f9a17f.jpg";